import React from 'react';
import ContentLoader from 'react-content-loader';

const FormContentLoader = props => (
  <ContentLoader
    height={700}
    width={676}
    speed={2}
    primaryColor="#f3f3f3"
    secondaryColor="#ecebeb"
    {...props}
  >
    <rect x="10" y="5" rx="0" ry="0" width="99" height="20" />
    <rect x="10" y="45" rx="0" ry="0" width="652" height="52" />
    <rect x="10" y="145" rx="0" ry="0" width="136" height="20" />
    <rect x="10" y="195" rx="0" ry="0" width="646" height="52" />
    <rect x="10" y="280" rx="0" ry="0" width="288" height="20" />
    <rect x="10" y="340" rx="0" ry="0" width="220" height="10" />
    <rect x="10" y="365" rx="0" ry="0" width="440" height="10" />
    <rect x="10" y="390" rx="0" ry="0" width="440" height="10" />
    <rect x="10" y="440" rx="0" ry="0" width="646" height="205" />
  </ContentLoader>
);

export default FormContentLoader;
